<template>
  <GestionBodegaGerencia />
</template>
<script>
import GestionBodegaGerencia from "./components/GestionBodegaGerencia";
export default {
  components: { GestionBodegaGerencia },
};
</script>
